import React from 'react';
import * as _ from 'lodash';

const SCROLL_LOAD_OFFSET = 0; // scroll load trigger offset height

/**
 * @description スクロールで追加ロードを行うコンポーネント
 * @prop {Number} margin
 * @prop {Function} callback
 * @prop {String} targetId スクロールする要素
 */
export default class WorksInfinityScrollLoad extends React.Component {
  constructor(props) {
    super(props);

    this.margin = props.margin || 60;

    this.state = {
      is_load: false,
    };

    const num = _.uniqueId();

    this.ID = `infinity-scroll-div-element-${num}`;
    this.is_remove = false;
    this.removeScrollEvent = () => {};
  }

  componentDidMount() {
    this.setCallback();
  }

  componentWillUnmount() {
    this.removeScrollEvent();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.reset && this.is_remove) {
      this.setCallback();
    }
  }

  setCallback() {
    if (_.isString(this.props.targetId)) {
      const target = document.getElementById(this.props.targetId);
      const callback = this.scrollCallBack.bind(this);
      if (!target) {
        return;
      }

      //console.log("infinity scroll Load DidMount", target , this.ID );

      // イベント登録する
      target.addEventListener('scroll', callback);
      this.removeScrollEvent = () => {
        this.is_remove = true;
        target.removeEventListener('scroll', callback);
      };

      this.is_remove = false;
    }
  }

  //スクロールイベントで呼ばれ続けるのでthrottleで100ミリ秒間隔にする
  scrollCallBack = _.throttle(() => {
    const workTableWrapper = document.getElementById(this.props.targetId);
    if (workTableWrapper) {
      if (
        workTableWrapper.scrollHeight - SCROLL_LOAD_OFFSET <=
          workTableWrapper.scrollTop + workTableWrapper.offsetHeight &&
        !this.state.is_load &&
        !this.props.loaded
      ) {
        if (this.props.callback) {
          let notify;
          if (!this.props.ignoreIndicator) {
            this.setState({ is_load: true });
            notify = this.notifyEnd.bind(this);
          }
          this.props.callback(notify);
        }
      }
    }
  }, 200);

  // 親からの 通信終了通知 を受け取る
  notifyEnd(type) {
    this.setState({ is_load: false });

    if (type === 'end') {
      this.removeScrollEvent();
    }
  }

  //インジケーターとメッセージ
  getLoaderElement() {
    if (this.props.isLoading) {
      return <div className='indicator' />;
    }
    if (this.props.LoaderElement) {
      return this.props.LoaderElement({
        id: this.ID,
        is_load: this.state.is_load,
      });
    } else {
      let elem = [];
      if (this.props.total > 0 && !this.props.loaded && this.state.is_load) {
        elem.push(<div key={this.ID} id={this.ID} className='indicator' />);
      } else {
        elem.push(<div key={this.ID} id={this.ID} />);
      }
      return elem;
    }
  }

  render() {
    return this.getLoaderElement();
  }
}



// WEBPACK FOOTER //
// ./src/components/WorksInfinityScrollLoad.jsx